import { UtcTime } from 'shared/models';

export const Actions = {
    WEBSOCKET_CONNECTING:   'WEBSOCKET_CONNECTING',
    WEBSOCKET_CONNECTED:    'WEBSOCKET_CONNECTED',
};

export const websocketConnecting = (meta: { started: UtcTime }) => ({
    type: Actions.WEBSOCKET_CONNECTING,
    meta,
});

export const websocketConnected = (connected: boolean, meta: { when: UtcTime }) => ({
    type: Actions.WEBSOCKET_CONNECTED,
    payload: connected,
    meta,
});
